import { render, staticRenderFns } from "./SelectorDictamen.vue?vue&type=template&id=ac71c604"
import script from "./SelectorDictamen.vue?vue&type=script&lang=js"
export * from "./SelectorDictamen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports